import { Fragment } from 'react'
import { Box, styled } from '@mui/material'
import {
    Attribute,
    AttributeLabel,
    AttributeValue,
    Divider,
    RiskIndicator,
    StatusIndicator,
} from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { MOBILE_SCREEN_WIDTH } from 'packages/core/utils/constants'
import { SubjectTypeAttribute } from 'components'
import { expandedAttributes } from './attributes'
import moment from 'moment'

const Content = styled(Box)(({ theme }) => ({
    '&.hasAttributes': {
        width: '100%',

        padding: theme.spacing(2),
        [`@media (max-width:${MOBILE_SCREEN_WIDTH - 1}px)`]: {
            paddingBottom: theme.spacing(2),
        },
        [`@media (max-width:345px)`]: {
            flexDirection: 'column-reverse',
        },
    },
}))

const Section = styled(Box)(({ theme }) => ({
    '&.hasAttributes': {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [`@media (max-width:${MOBILE_SCREEN_WIDTH - 1}px)`]: {
            display: 'none',
        },
    },
}))
const CellDateTime = ({ value }) => (
    <>{value ? moment.utc(value).local().format('LLL') : '-'}</>
)
export const ExpandedContent = (props) => {
    const attributes = expandedAttributes()
    const { t } = useTranslation()
    const { data, isLoading, orientation = 'vertical' } = props
    const getStatusVariant = (status) => {
        if (status === 'Open Pending Item Approval') {
            return 'Open_PendingItemApproval'
        } else if (status === 'Open Pending Approval') {
            return 'Open_PendingApproval'
        }
        return status
    }
    const renderComponent = (a, item) => {
        switch (a.component.componentName) {
            case 'StatusIndicator':
                const itemStatus = item.preApproved
                    ? 'PreApproved'
                    : item[a.name]
                return (
                    <>
                        {itemStatus ? (
                            <Box sx={{ maxWidth: '15.4rem' }}>
                                <StatusIndicator
                                    className="Status-Indicator"
                                    style={a.component.styles}
                                    variant={getStatusVariant(itemStatus)}
                                    label={t(`${itemStatus}`)}
                                    {...a.component.props}
                                />
                            </Box>
                        ) : (
                            '-'
                        )}
                    </>
                )
            case 'RiskIndicator':
                return item[a.component.name] ? (
                    <Box
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'center'}
                    >
                        <RiskIndicator
                            variant={item[a.component.name]}
                            label={t(`${item[a.component.name]}Risk`)}
                            {...a.component.props}
                        />
                    </Box>
                ) : (
                    <>-</>
                )

            case 'CellDateTime':
                return <CellDateTime value={item[a.name]} />

            case 'SubjectType':
                const subjectType = item.subjectType
                return (
                    <SubjectTypeAttribute
                        subjectType={subjectType}
                        item={item}
                        personComponentProps={{ ...a.component.props }}
                    />
                )
            case 'Percentage':
                return item[a.name] === null
                    ? '-'
                    : `${parseFloat(item[a.name]) * 100}%`
            default:
                return <></>
        }
    }
    return (
        <>
            {isLoading ? (
                <Box width={'100%'}>
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Content
                    className={attributes.length > 1 ? 'hasAttributes' : ''}
                >
                    {attributes.map((section, si) => {
                        return (
                            <Box key={`box_section_${si}_${data?.id}`}>
                                <Section
                                    className={
                                        attributes.length > 1
                                            ? 'hasAttributes'
                                            : ''
                                    }
                                    key={`section_${si}_${data?.id}`}
                                >
                                    {section
                                        ?.filter(
                                            (att) =>
                                                att.display !== false &&
                                                att.display !== null,
                                        )
                                        .map((att, ai) => {
                                            return (
                                                <Attribute
                                                    orientation={orientation}
                                                    key={`section${si}_attributes_${ai}_${att.label}`}
                                                    sx={{
                                                        paddingTop:
                                                            '0 !important',
                                                    }}
                                                >
                                                    <AttributeLabel>
                                                        {t(att.label)}
                                                    </AttributeLabel>
                                                    <AttributeValue
                                                        sx={{
                                                            paddingTop:
                                                                '1.6rem !important',
                                                        }}
                                                    >
                                                        {data
                                                            ? att.component
                                                                ? renderComponent(
                                                                      att,
                                                                      data,
                                                                  )
                                                                : data[att.name]
                                                            : '-'}
                                                    </AttributeValue>
                                                </Attribute>
                                            )
                                        })}
                                </Section>
                                {si !== attributes.length - 1 && (
                                    <Box sx={{ my: '2.4rem' }}>
                                        <Divider color={'#f8f8f8'} />
                                    </Box>
                                )}
                            </Box>
                        )
                    })}
                </Content>
            )}
        </>
    )
}
